import { Icon } from '@graftcode/design-system'

import { SEARCH_MODAL_ITEM_KIND } from './modalItemKind.const'

export const ICON_MAP = {
  [SEARCH_MODAL_ITEM_KIND.QuickStart]: Icon.FastForwardRegular,
  [SEARCH_MODAL_ITEM_KIND.Glossary]: Icon.BookRegular,
  [SEARCH_MODAL_ITEM_KIND.Documentation]: Icon.DocumentRegular,
  [SEARCH_MODAL_ITEM_KIND.Service]: Icon.DSService,
  [SEARCH_MODAL_ITEM_KIND.Graft]: Icon.BoxRegular,
  [SEARCH_MODAL_ITEM_KIND.Module]: Icon.BoxRegular,
  [SEARCH_MODAL_ITEM_KIND.Gateway]: Icon.DSCodeGatewayFilled,
  [SEARCH_MODAL_ITEM_KIND.Action]: Icon.ArrowRoutingRegular,
}
